import { selectAppStore } from '../../../api';
import { useFooterData } from '../../../hooks';
import { DownloadLink } from './DownloadLink';

export function AppDownload() {
  const data = useFooterData();
  const appStore = selectAppStore(data).sort((a, b) => a.queue - b.queue);

  return (
    <div className="tlw-hidden tlw-grid-cols-[80px_120px] tlw-gap-3 lg:tlw-grid">
      <div>
        <DownloadLink downloadInfo={appStore[2]} />
      </div>
      <div className="tlw-grid tlw-gap-3">
        <DownloadLink downloadInfo={appStore[0]} />

        <DownloadLink downloadInfo={appStore[1]} />
      </div>
    </div>
  );
}
